<template>
  <component
    :is="element"
    :disabled="disabled"
    :type="type"
    :href="!disabled ? href : null"
    @click="handleClick"
    :aria-label="title"
    :dusk="dusk"
    :class="[styleClasses, sizeClasses, borderClasses, accessibleClasses, 'inline-block', 'text-center', 'rounded']"
  >
    <span v-if="icon" :class="icon"></span>
    <span :class="{ 'pl-1': icon && $slots.default }">
      <slot></slot>
    </span>
  </component>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: 'blue-500',
    },
    small: {
      type: Boolean,
      default: false,
    },
    href: {
      type: String,
      default: null,
    },
    active: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    accessible: {
      type: Boolean,
      default: false,
    },
    border: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    dusk: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      primaryColor: this.color,
      oppositColor: this.color === 'white' ? 'blue-500' : 'white',
      hoverClasses: null,
      focusClasses: null,
      accessibleClasses: null,
    };
  },
  methods: {
    handleClick(evt) {
      if (this.element == 'button') this.$emit('click', evt);
    },
    getActiveClasses() {
      return (
        ' border-2 bg-' +
        this.primaryColor +
        ' border-' +
        this.primaryColor +
        ' cursor-default duration-150 font-bold transition-all text-' +
        this.oppositColor +
        ' active'
      );
    },
    getDisabledClasses() {
      return ' border-2 bg-gray-500 border-gray-700 cursor-default font-bold text-gray-700';
    },
    setHoverClasses() {
      this.hoverClasses =
        ' cursor-pointer hover:text-' + this.oppositColor + ' hover:bg-opacity-75 hover:bg-' + this.primaryColor;
    },
    setFocusClasses() {
      this.focusClasses = ' focus:text-' + this.oppositColor + ' focus:bg-opacity-75 focus:bg-' + this.primaryColor;
    },
    setAccessibleClasses() {
      this.accessibleClasses =
        'bg-blue-500 text-white hover:bg-white hover:text-blue-500 focus:bg-white focus:text-blue-500 border border-blue-500';
    },
    getDefaultClasses() {
      return (
        ' border-2 border-' +
        this.primaryColor +
        ' duration-150 font-bold transition-all text-' +
        this.primaryColor +
        this.hoverClasses +
        this.focusClasses
      );
    },
  },
  computed: {
    styleClasses() {
      if (this.active === true) {
        return this.getActiveClasses();
      } else if (this.disabled === true || this.disabled === 'disabled') {
        return this.getDisabledClasses();
      } else if (this.accessible == true) {
        return this.setAccessibleClasses();
      } else {
        this.setHoverClasses();
        this.setFocusClasses();
        return this.getDefaultClasses();
      }
    },
    sizeClasses() {
      return this.small === true ? ' px-2 py-1 text-sm' : ' px-4 py-2';
    },
    borderClasses() {
      return !this.border && this.small ? ' border-none' : '';
    },
    element() {
      return this.href ? 'a' : 'button';
    },
    type() {
      return this.element == 'button' ? 'button' : null;
    },
  },
};
</script>
